/**
 * created by xcc on 2022/3/1
 * 融媒投递关系接口
 */

import request from "../../../base/request";

let host = "/cm-sites-pms/columnSync/";

const Apis = {
    getListData: host + "pageListColumnSync", //融媒投递关系列表
    getCurrentDeptColumnTree: '/cm-sites-pms/column/getColumnTrees', //获取当前部门的所有融媒栏目树
    saveColumnSyn: host + 'saveColumnSyn', //保存
    deleteColumnSynById: host + 'deleteColumnSynById', //删除
}

export const getListData = (body, callBack) => {
    request({url: Apis.getListData, body, callBack});
};
export const getCurrentDeptColumnTree = (body, callBack) => {
    request({url: Apis.getCurrentDeptColumnTree, body, callBack});
};
export const saveColumnSyn = (body, callBack) => {
    request({url: Apis.saveColumnSyn, contentType: "json", method: "post", body, callBack});
};
export const deleteColumnSynById = (body, callBack) => {
    request({url: Apis.deleteColumnSynById, method: "post", body, callBack});
};